module.exports = __webpack_public_path__ + "media/pipe3.c867b17e.webm";